module.exports = __webpack_public_path__ + "img/salud.4652ebed.png";